import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const handleNewsletterSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      alert('订阅成功！感谢您的关注。');
      form.reset();
      return;
    }
    const body = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key !== 'phone_alt') {
        body.append(key, value as string);
      }
    });
    fetch('https://readdy.ai/api/form/d9rct3knlsngrm4lmac0', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString(),
    })
      .then(res => res.text())
      .then(text => {
        let parsed: Record<string, unknown> = {};
        try { parsed = JSON.parse(text); } catch (_e) { parsed = {}; }
        const code = parsed?.code;
        if (code === 'OK') {
          alert('订阅成功！感谢您的关注。');
          form.reset();
        } else {
          const msg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后再试。';
          alert(msg);
        }
      })
      .catch(() => {
        alert('网络错误，请稍后再试。');
      });
  };

  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="inline-block text-xl font-bold font-heading text-background-50 mb-4 whitespace-nowrap">
                精品一区二区
              </Link>
              <p className="text-sm text-background-300 leading-relaxed mt-3">
                汇聚全网优质内容资源，严格分区筛选，为您提供高品质的精选内容体验。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4 whitespace-nowrap">快速导航</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-background-300 hover:text-background-100 transition-colors duration-200 whitespace-nowrap">
                    首页
                  </Link>
                </li>
                {categories.map(cat => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-300 hover:text-background-100 transition-colors duration-200 whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
                <li>
                  <Link to="/about" className="text-sm text-background-300 hover:text-background-100 transition-colors duration-200 whitespace-nowrap">
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4 whitespace-nowrap">热门标签</h4>
              <div className="flex flex-wrap gap-2">
                {['人工智能', '健康生活', '数字化转型', '旅行探索', '设计美学', '新能源', '区块链', '美食文化'].map(tag => (
                  <Link
                    key={tag}
                    to="/"
                    className="px-3 py-1 text-xs bg-background-800 text-background-300 rounded-full hover:bg-background-700 hover:text-background-100 transition-colors duration-200 whitespace-nowrap"
                  >
                    {tag}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4 whitespace-nowrap">订阅更新</h4>
              <p className="text-sm text-background-300 mb-4 leading-relaxed">
                订阅我们的newsletter，每周获取精选内容推送。
              </p>
              <form
                data-readdy-form="newsletter"
                onSubmit={handleNewsletterSubmit}
                className="flex flex-col gap-2"
              >
                <div className="contact-alt-wrap">
                  <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                </div>
                <div className="flex flex-col sm:flex-row gap-2">
                  <input
                    type="email"
                    name="email"
                    placeholder="您的邮箱地址"
                    className="flex-1 px-4 py-2.5 text-sm bg-background-800 text-background-100 border border-background-700 rounded-lg focus:outline-none focus:border-primary-500 transition-colors duration-200 placeholder:text-background-500"
                    required
                  />
                  <button
                    type="submit"
                    className="px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-lg hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
                  >
                    订阅
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div className="border-t border-background-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400 whitespace-nowrap">
              &copy; {currentYear} 精品一区二区 版权所有
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors duration-200 whitespace-nowrap">
                隐私政策
              </a>
              <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors duration-200 whitespace-nowrap">
                服务条款
              </a>
              <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors duration-200 whitespace-nowrap">
                内容声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}